import { authedRequest } from './requests'

/**
 *
 * /channels resource requests
 *
 */
/**
 *
 * /registrations resource requests
 *
 */
export const patchAccount =
  (token, data) => {

    const body = {
      user: {
      first_name: data.first_name,
      last_name: data.last_name,
      company: data.company,
      email: data.email,
      password: data.password
      }
    }

    return authedRequest('v2/registrations', token, {
      method: 'PATCH',
      body: JSON.stringify({
        ...body
      })
    }).then(r => r);
  }

export const resendEmailConfirmation =
  (token) => {
    authedRequest('v2/registration/resend_email_confirmation', token, {
      method: 'POST'
    })
  }



// WEBPACK FOOTER //
// ./src/utils/api/accounts.js